import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { dv360TargetingSelector } from '../../../../../../modules/selectors/dv360Constants'

import { getLineItemLanguages } from './helpers'

const LanguagesSectionPreview = () => {
  const targeting = useSelector(dv360TargetingSelector)

  const lineItemLanguages = useMemo(() => getLineItemLanguages(targeting), [targeting])

  if (lineItemLanguages.length) {
    return (
      <p>
        {lineItemLanguages.map(language => {
          return <span key={language.value}>{language.label}</span>
        })}
      </p>
    )
  }

  return <p>All languages</p>
}

export default LanguagesSectionPreview
